import React from "react";
import btch from "../Assets/OurProgram/btch.webp";
import mangement from "../Assets/OurProgram/mangement.webp";
import mca from "../Assets/OurProgram/mca.webp";
import pharmacy from "../Assets/OurProgram/pharmacy.webp";
import CS from "../Assets/OurProgram/com-s.webp";
import nursing from "../Assets/OurProgram/nursing.webp";


const OurProgram = () => {
  return (
    <div id="programID" className="programBG">
      <div className="program-title">
        <h3>
          Discover Your Path: Our College Programs Tailored For Your Success
        </h3>
        <h1>PROGRAMS</h1>
      </div>
    <div className="program">
        <div className="program-card">
         <h2>ENGINEERING</h2>
         <img src={btch} alt="" />     
        </div>
        <div className="program-card">
         <h2>MANAGEMENT</h2>
         <img src={mangement} alt="" />     
        </div>
        <div className="program-card">
         <h2>COMPUTER APPLICATIONS</h2>
         <img src={mca} alt="" />     
        </div>
        <div className="program-card">
         <h2>PHARMACY</h2>
         <img src={pharmacy} alt="" />     
        </div>
        <div className="program-card">
         <h2>COMMERCE & SCIENCES</h2>
         <img src={CS} alt="" />     
        </div>
        <div className="program-card">
         <h2>PARAMEDICAL | NURSING | LAW</h2>
         <img src={nursing} alt="" />     
        </div>
    </div>

    </div>
  );
};
export default OurProgram;
